module.exports = __webpack_public_path__ + "static/media/url-short.4581bcbd.jpg";